/**
 * T049: Authenticated Layout Route
 * Layout route for protected pages with auth check
 */

import { createFileRoute, redirect } from '@tanstack/react-router'
import { RootLayout } from '@/components/layout/root-layout'
import { queryKeys } from '@/lib/query-keys'
import { getMe, ApiError } from '@/services/auth'

interface AuthMeResponse {
  user: {
    id: string
    email: string
    name: string
  }
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    try {
      const data = await context.queryClient.fetchQuery<AuthMeResponse>({
        queryKey: queryKeys.auth.me(),
        queryFn: () => getMe(),
        staleTime: 1000 * 60, // 1 minute
        retry: false,
      })
      if (!data?.user) {
        throw redirect({ to: '/sign-in' })
      }
    } catch (error) {
      // Redirect to sign-in on 401 unauthorized
      if (error instanceof ApiError && error.status === 401) {
        throw redirect({ to: '/sign-in' })
      }
      // Re-throw redirect errors (they are not Error instances)
      throw error
    }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return <RootLayout />
}
